import { render, staticRenderFns } from "./AdminMyAccount.vue?vue&type=template&id=1fa7191b"
import script from "./AdminMyAccount.vue?vue&type=script&lang=js"
export * from "./AdminMyAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fa7191b')) {
      api.createRecord('1fa7191b', component.options)
    } else {
      api.reload('1fa7191b', component.options)
    }
    module.hot.accept("./AdminMyAccount.vue?vue&type=template&id=1fa7191b", function () {
      api.rerender('1fa7191b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminMyAccount.vue"
export default component.exports